import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import Switch from "react-switch";
import axios from "axios";
import debounce from 'lodash.debounce';

const ReportCardLevelAnswer = props => {
  const { answer } = props;
  const { index } = props;
  const { safetySwimSkill } = props;

  return (
    <div className="row">
      <div className="col-xs-12">
        <b>
          {answer.name}
          {safetySwimSkill}
        </b>
      </div>
      <div className="col-xs-2 col-sm-1">
        <br />
        <Switch
          checked={answer.passed == true}
          onChange={e => props.togglePass(e, answer, index)}
          onColor="#DADCE1"
          onHandleColor="#3A4590"
          handleDiameter={25}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={48}
          className="react-switch"
          id="material-switch"
        />
      </div>
      <div className="col-xs-10 col-sm-11">
        <br />
        <div className="form-group">
          <input
            className="form-control"
            name="notes"
            type="text"
            placeholder="Notes..."
            value={answer.notes || ""}
            onChange={e => props.setNotes(e, answer, index)}
          />
        </div>
      </div>
    </div>
  )
};

class ReportCardLevel extends React.Component {

  state = {
    reportCardLevel: {},
    groupLessonPrograms: this.props.groupLessonPrograms,
    next_level: ''
  }

  constructor(props) {
    super(props);
    this.updateReportCardLevelDebounced = debounce(this.updateReportCardLevelDebounced, 500);
  }

  componentDidUpdate() {
    this.settingCompletedAt();
  }

  settingCompletedAt = () => {
    var date = this.props.reportCardLevel.completed_at ? new Date(this.props.reportCardLevel.completed_at) : null;
    var refCompletedAt = null;

    var datetimepicker = $(this.refCompletedAt).kendoDateTimePicker({
      value: date,
      change: e => {
        const value = e.sender.value();
        this.handleReportCardChange({ target: { value } }, "completed_at")
      }
    });

    if (!date) {
      datetimepicker.val("");
    }
  };

  markSent = () => {
    if (this.props.emailPdfCompleteReportCard) {
      for (var reportCardLevel of this.props.reportCard.active_report_card_levels) {
        reportCardLevel.sent = true;
        reportCardLevel.sent_at = new Date();
        this.props.updateReportCardLevel(reportCardLevel);
      }
    } else {
      var reportCardLevel = this.props.reportCardLevel;
      reportCardLevel.sent = true;
      reportCardLevel.sent_at = new Date();
      this.props.updateReportCardLevel(reportCardLevel);
    }
  };

  emailRecordCard = () => {
    var that = this;
    var emailReportCardData = {
      email_pdf_complete_report_card: this.props.emailPdfCompleteReportCard
    }

    if (this.props.groupLesson) {
      emailReportCardData.group_lesson_id = this.props.groupLesson.id
    }

    axios
      ({
        method: 'get',
        url: "/report_card_levels/" + this.props.reportCardLevel.id + "/email/",
        params: emailReportCardData
      })
      .then(function(response) {
        toastr.info("Report card queued for sending...");
        that.markSent();
      })
      .catch(function(error) {
        toastr.error("Error: unable to generate a report card");
      });
  };

  updateReportCardLevelDebounced = (reportCardLevel, answers_params, groupLessonId, oldStatus) => {
    var updateReportCardLevelUrl;

    if (groupLessonId) {
      updateReportCardLevelUrl = "/report_card_levels/" +
        reportCardLevel.id +
        ".json?group_lesson_id=" +
        groupLessonId
    } else {
      updateReportCardLevelUrl = "/report_card_levels/" +
        reportCardLevel.id +
        ".json"
    }

    const reportCardLanguage = this.props.reportCard.group_lesson_program.report_card_language
    let params = {
      notes: reportCardLevel.notes,
      completed_at: reportCardLevel.completed_at,
      answers_attributes: answers_params,
      next_level: this.state.next_level
    }

    if (reportCardLevel.status !== oldStatus)
      params.status = reportCardLevel.status

    axios
      .put(updateReportCardLevelUrl,
      {
        report_card_level: params
      })
      .then(function(response) {
        toastr.info(`${reportCardLanguage} updated`);
      })
      .catch(function(error) {
        toastr.error(`${reportCardLanguage} not saved`);
        console.log(error);
      });
  }

  putUpdatedReportCardLevel = (reportCardLevel, oldStatus) => {
    oldStatus = oldStatus || this.props.reportCardLevel.status
    this.props.updateReportCardLevel(reportCardLevel);
    var answers_params = reportCardLevel.answers.reduce(
      (map, answer, index) => (map[index] = answer, map), {}
    );
    this.updateReportCardLevelDebounced(reportCardLevel, answers_params, (this.props.groupLesson ? this.props.groupLesson.id : null), oldStatus);
  }

  setNotes = (e, answer, index) => {
    var reportCardLevel = this.props.reportCardLevel;
    reportCardLevel.answers[index].notes = e.target.value;
    this.putUpdatedReportCardLevel(reportCardLevel);
  };

  togglePass = (e, answer, index) => {
    var reportCardLevel = this.props.reportCardLevel
    reportCardLevel.answers[index].passed = !reportCardLevel.answers[index].passed
    this.putUpdatedReportCardLevel(reportCardLevel);
  };

  handleReportCardChange = (e, column) => {
    var reportCardLevel = this.props.reportCardLevel
    reportCardLevel[column] = e.target.value;
    this.putUpdatedReportCardLevel(reportCardLevel);
  };

  toggleLevelPass = (e, newStatus) => {
    let oldStatus = this.props.reportCardLevel.status
    var reportCardLevel = this.props.reportCardLevel;
    reportCardLevel.status = newStatus;
    this.putUpdatedReportCardLevel(reportCardLevel, oldStatus);
  };

  safetySwimSkill = (answer) => {
    if (this.props.useSafetySwimSkills) {
      if (answer.safety_skill == "1") {
        return " - Safety Skill"
      } else if (answer.swim_skill == "1") {
        return " - Swim Skill"
      }
    }
  }

  selectNextLevelForGroupLessonProgramLevel = (e) => {
    this.setState({ next_level: e.target.value});
    this.putUpdatedReportCardLevel(this.props.reportCardLevel);
    this.props.setNextLevel(e.target.value)
  }

  activeGroupLessonPrograms = () => {
    return _.filter(this.state.groupLessonPrograms, { archived: false, template: false })
  }

  render() {
    return (
      <div>
        {this.props.reportCardLevel.answers.map((answer, index) =>
          <ReportCardLevelAnswer
            answer={answer}
            safetySwimSkill={this.safetySwimSkill(answer)}
            togglePass={(e) => this.togglePass(e, answer, index)}
            setNotes={(e) => this.setNotes(e, answer, index)}
            index={index}
            key={index}
          />
        )}
        <label>Notes</label>
        <textarea
          rows="3"
          cols="80"
          className="form-control"
          placeholder="Add note..."
          type="text"
          value={this.props.reportCardLevel.notes || ""}
          onChange={e => this.handleReportCardChange(e, "notes")}
        />
        <hr />
        <div className="row">
          <div className="col-md-6">
            <label>Status for this Level</label>
          </div>
          <div className="col-md-1">
            <label>{this.props.failedString}</label>
          </div>
          <div className="col-md-1">
            <Switch
              checked={this.props.reportCardLevel.status == "2"}
              onChange={e => this.toggleLevelPass(e, 2)}
              onColor="#DADCE1"
              onHandleColor="#3A4590"
              handleDiameter={25}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
            />
          </div>
          <div className="col-md-1 col-md-offset-1">
            <label>{this.props.passedString}</label>
          </div>
          <div className="col-md-1">
            <Switch
              checked={this.props.reportCardLevel.status == "3"}
              onChange={e => this.toggleLevelPass(e, 3)}
              onColor="#DADCE1"
              onHandleColor="#3A4590"
              handleDiameter={25}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <label
              className="control-label required"
            >
              Next Recommended Level
            </label>

            <select
              id="certificationTypeUnits"
              className="form-control"
              onChange={e => this.selectNextLevelForGroupLessonProgramLevel(e)}
            >
              <option value='' defaultValue>
                Choose level
              </option>
              {
                this.activeGroupLessonPrograms().map((groupLessonProgram) => {
                  return groupLessonProgram.active_group_lesson_levels.map((groupLessonLevel) => {
                    let level_name = groupLessonProgram.name + " - " + groupLessonLevel.name;
                    if(level_name === this.props.reportCardLevel.next_level){
                      return <option value={level_name} selected>{level_name}</option>
                    } else {
                      return <option value={level_name}>{level_name}</option>
                    }
                  })
                })
              }
            </select>
          </div>
        </div>
        <label>Date Completed</label>
        <div>
          <input ref={el => this.refCompletedAt = el} />
        </div>
        <hr />
        {this.props.reportCardLevel.sent ? (
          <button
            className="btn btn-block btn-indigo full-width"
            onClick={() => this.emailRecordCard()}
          >
            {
              "RE-EMAIL " +
              this.props.reportCardLanguage.toUpperCase() +
              (this.props.emailPdfCompleteReportCard ? " (ALL LEVELS)" : "")
            }
          </button>
        ) : (
          <button
            className="btn btn-block btn-pink full-width"
            onClick={() => this.emailRecordCard()}
          >
          {
            "EMAIL " +
            this.props.reportCardLanguage.toUpperCase() +
            (this.props.emailPdfCompleteReportCard ? " (ALL LEVELS)" : "")
          }
          </button>
        )}
      </div>
    )
  }
}

ReportCardLevel.propTypes = {
  reportCardLevel: PropTypes.object
};

export default ReportCardLevel;
